export default {
  name: 'GraphicRiver',
  abbreviation: 'GR',
  domain: 'graphicriver.net',
  google_analytics_id: 'UA-11834194-6',
  google_remarketing_label: 'hJ8ZCL2AugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. brochure template',
  assets_domains: {
    item_thumbnail: 'thumb-gr.s3.envato.com',
    item_image: 'image-gr.s3.envato.com'
  },
  feeds_categories: [
    '/graphics',
    '/print-templates',
    '/epublishing',
    '/textures',
    '/vectors',
    '/infographics',
    '/add-ons',
    '/isolated-objects',
    '/icons',
    '/presentation-templates',
    '/fonts',
    '/web-elements',
    '/logo-templates',
    '/t-shirts',
    '/game-assets'
  ],
  features: {
    'routes:new': true,
    'experiments:loading-cover': true,
    'transition-to-new-design': true
  }
}
